import icon1 from '../../../Assets/Icons/why1.svg';
import icon2 from '../../../Assets/Icons/why2.svg';
import icon3 from '../../../Assets/Icons/why3.svg';
import icon4 from '../../../Assets/Icons/why4.svg';
import icon5 from '../../../Assets/Icons/why5.svg';
import icon6 from '../../../Assets/Icons/why6.svg';

import bg1 from '../../../Assets/Backgrounds/globalCard1.webp';
import bg2 from '../../../Assets/Backgrounds/globalCard2.webp';
import bg3 from '../../../Assets/Backgrounds/globalCard3.webp';
import bg4 from '../../../Assets/Backgrounds/globalCard4.webp';

import p1 from '../../../Assets/Icons/support.svg';
import p2 from '../../../Assets/Icons/megaphone.svg';
import p3 from '../../../Assets/Icons/engineer.svg';
import p4 from '../../../Assets/Icons/vector.svg';






export const globalData = [
    {
        backgroundImage:bg1,
        delay:100,
        location:"USA",
        Color:"#EC6423",
        desc:"From our HQ in Redwood City to our other hubs such as New York City, Chicago, Austin, and all our remote locations, we power how the world works together from anywhere."
    },
    {
        backgroundImage:bg2,
        location:"EMEA",
        delay:200,
        Color:"#FF4F5A",
        desc:"HostDesign is a company that is continuing to expand our presence globally. We have HostDesigner in locations from London, Paris, Munich, Amsterdam and more."
    },
    {
        backgroundImage:bg3,
        location:"Poland",
        delay:300,
        Color:"#17A7EC",
        desc:"Welcome to our newest office in Warsaw, Poland. With HostDesign’s continuing growth, we have expanded our presence to a new hub location. "
    },
    {
        backgroundImage:bg4,
        location:"Japan",
        delay:400,
        Color:"#622AF2",
        desc:"HostDesign is securely connecting all over the world, including APAC. With our main offices in Osaka and Tokyo, we are collaborating in more places than ever. "
    }
]
export const whyData = [
    {
        icon:icon1,
        title:"Friendly Environment",
        bgColor:"#F1EBFF",
        bgColor2:"#622AF2"
    },
    {
        icon:icon2,
        title:"Open Communication",
        bgColor:"#ec63233b",
        bgColor2:"#EC6423"
    },
    {
        icon:icon3,
        title:"Upgrade Your Skills",
        bgColor:"#ffbf002d",
        bgColor2:"#FFC000"
    },
    {
        icon:icon4,
        title:"Challenge the World",
        bgColor:"#02eb0223",
        bgColor2:"#02EB02"
    },
    {
        icon:icon5,
        title:"Learning Opportunity",
        bgColor:"#ff4f5b2f",
        bgColor2:"#FF4F5A"
    },
    {
        icon:icon6,
        title:"Secured Future",
        bgColor:"#17a8ec25",
        bgColor2:"#17A7EC"
    }
]

export const positions = [
    {
     icon:p1,
     sub:"Support",
     title:"Technical Support Engineer",
     desc1:"Job Type: Full Time - No. of Vacancies: 4 - Deadline: July 31, 2021",
     bgColor:"#F1EBFF",
     delay:100
    },
    {
        icon:p2,
        sub:"Marketing",
        bgColor:"#ec63233b",
        title:"Director of Marketing",
        desc1:"Job Type: Full Time - No. of Vacancies: 4 - Deadline: July 31, 2021",
        title2:"Marketing Analyst",
        desc2:"Job Type: Full Time - No. of Vacancies: 4 - Deadline: July 31, 2021",
        delay:200
     },
     {
        icon:p3,
        sub:"Engineering",
        bgColor:"#ff4f5b2f",
        title:"Lead Developer (React, Vanilla)",
        desc1:"Job Type: Full Time - No. of Vacancies: 4 - Deadline: July 31, 2021",
        title2:"Senior Web Application Developer",
        desc2:"Job Type: Full Time - No. of Vacancies: 4 - Deadline: July 31, 2021",
        delay:300
     },
     {
        icon:p4,
        sub:"Design",
        title:"Product Designer",
        bgColor:"#17a8ec25",
        desc1:"Job Type: Full Time - No. of Vacancies: 4 - Deadline: July 31, 2021",
        delay:300
       },
]
